import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchPaymentMethodDetails, addAutoPayEnroll, removeAutoPayEnroll } from "../../../../shared/hooks/useFetchPayment";
import { v4 as uuidv4 } from "uuid";
import API_URLS from "../../Utils/axr";
import { errorConditionGTM } from "../../Utils/googleTags";
import store from "../store";

type singlePaymentMethodsDetailsInitialStateType = {
  singlePaymentMethodsDetails: any;
  loading: boolean;
  error: any;
  singlePaymentLoading:boolean;
  enrollPaymentsLoading:boolean;
  enrollPaymentsError:any;
  paymentMethodListCC:any;
  paymentMethodListACH:any;
  defaultPayId:any;
  deletePaymentDetails:any;
  nextPrimaryPaymnetId: any;
  nextPrimaryMethod:any;
  defaultPayMethod:any;
  popupDetails:any;
  enrollResultSet:any;
  removeAutoPayLoading:boolean;
  removeAutoPayError: any;
  removeAutoPayResult:any;
  isManageAutoPay: boolean;
  autoPayRemoveFlag:string;
  enrollPaperlessBillingResultSet: any;
  enrollPaperlessBillingLoading: boolean;
  enrollPaperlessBillingError: any;
  enrollPostpaidFiberResultSet: any;
  enrollPostpaidFiberPaymentsLoading: boolean;
  enrollPostpaidFiberPaymentsError: any
};

const initialState: singlePaymentMethodsDetailsInitialStateType = {
  singlePaymentMethodsDetails: null,
  loading: false,
  error: null,
  singlePaymentLoading: false,
  enrollPaymentsLoading: false,
  enrollPaymentsError: null,
  paymentMethodListCC:null,
  paymentMethodListACH:null,
  defaultPayId:null,
  deletePaymentDetails:null,
  nextPrimaryPaymnetId:null,
  nextPrimaryMethod:null,
  defaultPayMethod:null,
  popupDetails:null,
  enrollResultSet:null,
  removeAutoPayLoading:false,
  removeAutoPayError:null,
  removeAutoPayResult:null,
  isManageAutoPay:false,
  autoPayRemoveFlag:"",
  enrollPaperlessBillingResultSet: null,
  enrollPaperlessBillingLoading: false,
  enrollPaperlessBillingError: null,
  enrollPostpaidFiberResultSet: null,
  enrollPostpaidFiberPaymentsLoading: false,
  enrollPostpaidFiberPaymentsError: null
};

export const getSinglePaymentMethodDetails = createAsyncThunk(
  "single/paymentMethod/details",
  async (cardId: string) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      let url=API_URLS?.addUpdatePaymentMethodUrl_QA;
      const response = await fetchPaymentMethodDetails(
        {
          [url]: cardId,
        },
        headers
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const enrollPaymentMethod = createAsyncThunk(
  "single/paymentMethod/enroll",
  async (body: any) => {
    try {
      const reduxStore = store.getState();
      const ban = reduxStore?.user?.data?.billingAccountNumber;
      const headers = reduxStore?.brightspeedToken?.headers;
      const baseline = {
        siteId: headers?.siteId?.toLowerCase(),
        billingType: "postpaid",
        transactionId:  headers?.sessionId,
      }
      let url=API_URLS['enrollAutoPay']
      const response = await addAutoPayEnroll(
        {
          [url]: ban,
        },
        {...body, baseline},
        headers
      );
      return response; 
    } catch (error) {
      throw error;
    }
  }
);

export const removeAutopay = createAsyncThunk(
  "single/paymentMethod/removeautopay",
  async (billingAccountNumber: any) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const isPaperlessBillingEnrolled = reduxStore?.planDetails?.paperLessBilling;
      const payload = {
        baseline: {
          transactionId: uuidv4().slice(0, 21),
          partnerId: "BS196123",
          salesCode: "20000660",
          referenceId: "",
          orderId: "",
          agentId: "",
          channel: "web-acm",
          billingType: headers?.billingType,
          siteId: headers?.siteId?.toLowerCase()
        },
        banNumber: billingAccountNumber,
        email: reduxStore?.user?.data?.email,
        Paperless_Ind: isPaperlessBillingEnrolled ? "ZY" : "ZN",
        // Autopay_Ind: "ZN"
      }
      let url=API_URLS["remove_autopay"];
      const response = await removeAutoPayEnroll(
        {
          "": `${url}`,
        },
        payload,
        headers
      );
      return response; 
    } catch (error) {
      throw error;
    }
  }
);

export const enrollPaperlessBilling = createAsyncThunk(
  "paperlessBilling/enroll",
  async (body: any) => {
    try {
      const reduxStore = store.getState();
      const ban = reduxStore?.user?.data?.billingAccountNumber;
      const headers = reduxStore?.brightspeedToken?.headers;
      let url=API_URLS['enrollAutoPay']

      const response = await addAutoPayEnroll(
        {
          [url]: ban,
        },
        body,
        headers
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const enrollPostpaidFiberPaperlessBilling = createAsyncThunk(
  "paperlessBilling/enroll",
  async (body: any) => {
    try {
      const reduxStore = store.getState();
      const ban = reduxStore?.user?.data?.billingAccountNumber;
      const headers = reduxStore?.brightspeedToken?.headers;
      const isAutopayEnrolled = reduxStore?.planDetails?.isAutoPayEnrolled;
      const paymentMethodTypeFromStore = reduxStore?.planDetails?.planDetails?.creditCard?.type;
      let paymentTypeValue = "NA"
      if (paymentMethodTypeFromStore) {
          if( ["SAVINGS", "CHECKING"].includes(paymentMethodTypeFromStore?.toUpperCase()) ) {
            paymentTypeValue = "ACH"
          }
          if (paymentMethodTypeFromStore?.toUpperCase() === "ATM") {
            paymentTypeValue = "DEBIT"
          }
          if (paymentMethodTypeFromStore?.toUpperCase() === "CREDITCARD") {
            paymentTypeValue = "CARD"
          }
      }
      // const Autopay_Ind = isAutopayEnrolled ? 'ZY' : 'ZN';
      const paymentType = isAutopayEnrolled ? paymentTypeValue : "NA"
      const baseline = {
        siteId: headers?.siteId?.toLowerCase(),
        billingType: "postpaid",
      }
      const emailAddress = reduxStore?.user?.data?.email;
      let url=API_URLS['enrollAutoPay']

      const response = await addAutoPayEnroll(
        {
          [url]: ban,
        },
        // {...body, Autopay_Ind, baseline},
        {...body, baseline, paymentType, emailAddress},
        headers
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const enrollPostpaidFiberAutopay = createAsyncThunk(
  "postpaidFiberAutopay/enroll",
  async (body: any, {rejectWithValue}) => {
    try {
      const reduxStore = store.getState();
      const ban = reduxStore?.user?.data?.billingAccountNumber;
      const headers = reduxStore?.brightspeedToken?.headers;
      const emailAddress = reduxStore?.user?.data?.email;
      const baseline = {
        siteId: headers?.siteId?.toLowerCase(),
        billingType: "postpaid",
      }
      let url=API_URLS['enrollAutoPay']

      const response = await addAutoPayEnroll(
        {
          [url]: ban,
        },
        {...body, baseline, emailAddress},
        headers
      );
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const singlePaymentMethodDetailSlice = createSlice({
  name: "single/paymentMethod",
  initialState,
  reducers: {
    setAddPaymentMethod: (state, action: PayloadAction<boolean>) => {
      state.singlePaymentMethodsDetails = action.payload;
    },
    setSinglePaymentloader :(state, action: PayloadAction<boolean>)=> {
      state.singlePaymentLoading = action.payload;
    },
    singlePaymentMethodDetailSliceSetInitialState: () => initialState,

    setDeletepayment: (state, action:PayloadAction<any>)=>{
      state.deletePaymentDetails = action.payload;
    },
    setPaymentListCC: (state, action:PayloadAction<any>)=>{
      state.paymentMethodListCC = action.payload;
    },
    setPaymentListACH: (state, action:PayloadAction<any>)=>{
      state.paymentMethodListACH = action.payload;
    },
    setDefaultPaymentId: (state, action:PayloadAction<any>)=>{
      state.defaultPayId = action.payload;
    },
    setNextPrimaryMethod:(state, action:PayloadAction<any>)=>{ 
      state.nextPrimaryMethod = action.payload;
    },
    setNextPrimaryPaymnetId:(state, action:PayloadAction<any>)=>{
      state.nextPrimaryPaymnetId = action.payload;
    },
    setDefaultPayment: (state, action:PayloadAction<any>)=>{
      state.defaultPayMethod = action.payload;
    },
    setPopupDetails:(state, action:PayloadAction<any>)=>{
      state.popupDetails = action.payload;
    },
    setEnrollDataSet:(state,action:PayloadAction<any>)=>{
      state.enrollResultSet = action.payload;
    },
    setManageAutoPayState:(state,action:PayloadAction<boolean>)=>{
      state.isManageAutoPay=action.payload;
    },
    setRemoveAutopayFlag: (state, action:PayloadAction<string>)=>{
      state.autoPayRemoveFlag = action.payload;
    },
     setPaperlessEnrollDataSet:(state,action:PayloadAction<any>)=>{
      state.enrollPaperlessBillingResultSet = action.payload;
    },
    setEnrollPostpaidFiberResultDataSet:(state,action:PayloadAction<any>)=>{
      state.enrollPostpaidFiberResultSet = action.payload;
    },
    clearEnrollPostpaidFiberPaymentsError:(state)=>{
      state.enrollPostpaidFiberPaymentsError = null;
    },
    clearEnrollPaymentsError:(state)=>{
      state.enrollPaymentsError = null;
    }
    

  },
  extraReducers: (builder) => {
    builder.addCase(getSinglePaymentMethodDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getSinglePaymentMethodDetails.fulfilled,
      (state, action) => {
        state.singlePaymentMethodsDetails = action.payload;
        state.loading = false;
        state.error = null;
      }
    );
    builder.addCase(getSinglePaymentMethodDetails.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "payment method by id",
        action.error?.message,
        action?.type
      );
      state.singlePaymentMethodsDetails = null;
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(enrollPaymentMethod.pending,(state)=>{
      state.enrollPaymentsLoading=true;
      
    });
    builder.addCase(enrollPaymentMethod.fulfilled,(state, action)=>{
        state.enrollResultSet = action.payload;
      state.enrollPaymentsLoading= false;
      state.enrollPaymentsError= null;
    });
    builder.addCase(enrollPaymentMethod.rejected,(state, action)=>{
      
      state.enrollPaymentsLoading= false;
      state.enrollPaymentsError= action.error;
    });

    builder.addCase(removeAutopay.pending, (state) => {
      state.removeAutoPayLoading = true;
    });
    builder.addCase(removeAutopay.fulfilled, (state, action) => {
      state.removeAutoPayResult = action.payload;
      state.removeAutoPayLoading = false;
      state.removeAutoPayError = null;
    });
    builder.addCase(removeAutopay.rejected, (state, action) => {
      state.removeAutoPayLoading = false;
      state.removeAutoPayError = action.error;
    });

    builder.addCase(enrollPaperlessBilling.pending, (state) => {
      state.enrollPaperlessBillingLoading = true;
    });
    
    builder.addCase(enrollPaperlessBilling.fulfilled, (state, action) => {
      state.enrollPaperlessBillingResultSet = action.payload;
      state.enrollPaperlessBillingLoading = false;
      state.enrollPaperlessBillingError = null;
    });

    builder.addCase(enrollPaperlessBilling.rejected, (state, action) => {
      state.enrollPaperlessBillingLoading = false;
      state.enrollPaperlessBillingError = action.error;
    });

    builder.addCase(enrollPostpaidFiberAutopay.pending, (state) => {
      state.enrollPostpaidFiberPaymentsLoading = true;
    });
    builder.addCase(enrollPostpaidFiberAutopay.fulfilled, (state, action) => {
      state.enrollPostpaidFiberResultSet = action.payload;
      state.enrollPostpaidFiberPaymentsLoading = false;
      state.enrollPostpaidFiberPaymentsError = null;
    });
    builder.addCase(enrollPostpaidFiberAutopay.rejected, (state, action) => {
      state.enrollPostpaidFiberPaymentsLoading = false;
      state.enrollPostpaidFiberPaymentsError = action.error;
    });
    
  },
});

export const {
  singlePaymentMethodDetailSliceSetInitialState,
  setAddPaymentMethod, setSinglePaymentloader,
  setDeletepayment,
  setDefaultPaymentId,
  setPaymentListACH,
  setPaymentListCC,
  setNextPrimaryMethod,
  setNextPrimaryPaymnetId,
  setDefaultPayment, 
  setPopupDetails,
  setEnrollDataSet,
  setManageAutoPayState,
  setRemoveAutopayFlag,
  setPaperlessEnrollDataSet,
  setEnrollPostpaidFiberResultDataSet,
  clearEnrollPostpaidFiberPaymentsError,
  clearEnrollPaymentsError,
} = singlePaymentMethodDetailSlice.actions;
export default singlePaymentMethodDetailSlice.reducer;
